import { Reveal, RevealText } from "@/components/Reveal";

export function PageHero({
  kicker,
  title,
  lead,
}: {
  kicker: string;
  title: string;
  lead: string;
}) {
  return (
    <section className="border-b border-line bg-ink px-5 pt-32 pb-16 md:px-8 md:pt-40 md:pb-24">
      <div className="mx-auto max-w-7xl">
        <p className="font-mono text-[10px] tracking-[0.35em] text-brass uppercase">{kicker}</p>
        <h1 className="font-display mt-5 max-w-5xl text-5xl leading-[0.9] md:text-8xl">
          <RevealText text={title} />
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-lg text-mute">{lead}</p>
        </Reveal>
      </div>
    </section>
  );
}
